import React, { useEffect, useState } from 'react'
import { TextField, FormMessage } from 'react-md'
import { usePromiseTracker } from 'react-promise-tracker'

import Cell from 'components/core/cell'

import { FieldProps } from './types'
import { useFormContext } from 'react-hook-form'

export const InputPhone = ({ name, desktopSize, tabletSize, disabled, ...rest }: FieldProps) => {
  const { promiseInProgress } = usePromiseTracker()
  const form = useFormContext()
  const [text, setText] = useState<string>('')
  const formValue = form.watch(name)

  useEffect(() => {
    form.register({ name })
  }, [form.register])

  useEffect(() => {
    setText(formValue ? formatPhone(String(formValue)) : '')
  }, [formValue])

  const formatPhone = (value: string): string => {
    if (value.length === 8) return value.replace(/\D/g, '').replace(/^(\d{4})(\d{4})+?$/, '$1-$2')
    else if (value.length === 9) return value.replace(/\D/g, '').replace(/^(\d{5})(\d{4})+?$/, '$1-$2')
    else if (value.length === 10) return value.replace(/\D/g, '').replace(/^(\d{2})(\d{4})(\d{4})+?$/, '($1)$2-$3')
    else if (value.length === 11) return value.replace(/\D/g, '').replace(/^(\d{2})(\d{5})(\d{4})+?$/, '($1)$2-$3')

    return value
  }

  return (
    <Cell tabletSize={tabletSize} desktopSize={desktopSize}>
      <TextField
        id={name}
        name={name}
        theme={'underline'}
        error={form.errors[name] ? true : false}
        disabled={disabled || promiseInProgress}
        value={text ?? ''}
        maxLength={14}
        onChange={selected => {
          if (form.errors[name]) form.clearError(name)
          if (selected.target.value) form.setValue(name, selected.target.value.replace(/\D/g, ''))
          else form.setValue(name, null)
        }}
        {...rest}
      />
      {form.errors[name] && (
        <FormMessage id={name} error style={{ paddingLeft: 0 }}>
          {form.errors[name].message}
        </FormMessage>
      )}
    </Cell>
  )
}
